import React, { useState,useEffect } from 'react';
import './css/eventform.css';
import { useNavigate } from 'react-router-dom';

const Help = () => {
	const [userId, setUserid] = useState('');
	const [message, setMessage] = useState('');
	const navigate = useNavigate();

	
	// Step 1: Set userId from localStorage
	useEffect(() => {
	  const storeduserId = localStorage.getItem('userId');
	  if (storeduserId) {
	    setUserid(storeduserId);
	  } else {
	    // Optional: redirect to login or show fallback
	    console.warn("No userId found in localStorage");
	 
	  }
	}, []);
	
	
    return (
	<div className="page-wrapper">		
		<div className='help-container '>
			<p> Please send email to <strong>contact@buydeal.eu</strong> for any queries</p>		
		</div>
	</div>	
    );
}


export default Help;
